// Where a task lands in the plan outline when it is dropped on a row, or
// inserted below one. `tasks` is the plan in display order; the result is the
// list of moves POST /project-tasks/outline takes, renumbering the siblings it
// lands among. `where` is 'before' or 'after' the target as a sibling, or
// 'into' the target as its first child. `id` need not be in `tasks` yet, which
// is how a task created at the bottom is put in its place.
export function dropMoves(tasks, id, targetId, where) {
  const byId = new Map(tasks.map(t => [t.id, t]));
  const target = byId.get(targetId);
  if (!target) return null;

  // Refuse the target itself, or anywhere inside the dragged row's own subtree.
  for (let p = target, guard = 0; p && guard++ < 50; p = byId.get(p.parent_task_id)) {
    if (p.id === id) return null;
  }

  const parentId = where === 'into' ? target.id : (target.parent_task_id || null);
  const sibs = tasks
    .filter(t => (t.parent_task_id || null) === parentId && t.id !== id)
    .map(t => t.id);
  const at = where === 'into' ? 0 : sibs.indexOf(targetId) + (where === 'after' ? 1 : 0);
  sibs.splice(at, 0, id);

  return sibs.map((sid, k) => (sid === id
    ? { id, parent_task_id: parentId, sort_order: k }
    : { id: sid, sort_order: k }));
}
